import { render, staticRenderFns } from "./IndexPredictionMarket.vue?vue&type=template&id=5e5dd394&scoped=true"
import script from "./IndexPredictionMarket.vue?vue&type=script&lang=js"
export * from "./IndexPredictionMarket.vue?vue&type=script&lang=js"
import style0 from "./IndexPredictionMarket.vue?vue&type=style&index=0&id=5e5dd394&prod&scoped=true&lang=css"
import style1 from "./IndexPredictionMarket.vue?vue&type=style&index=1&id=5e5dd394&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5dd394",
  null
  
)

export default component.exports